module.exports = __webpack_public_path__ + "media/facial-recognition/facial-target-830540e9.svg";